import { URLS } from 'api/constants';
import {
  ICasinoReview,
  ICasinoReviewGraph,
  IStreamersReviewsResult,
} from 'constants/types';
import { useMutation } from 'hooks/useMutation';
import { useQuery } from 'hooks/useQuery';
import { apiGet, apiRequest } from 'lib/api/client';
import { PaginationResponse } from 'lib/api/types';
import { HookQueryOptions, queryKey } from './shared';

interface CreateStreamerReviewsRequest {
  streamerId: string;
  rating: number;
  review: string;
}

interface ToogleLikeRequest {
  reviewId: string;
}

export const useStreamersLatestReviewsQuery = (
  _payload?: void,
  options?: HookQueryOptions
) =>
  useQuery<IStreamersReviewsResult>(
    queryKey('streamerReviews.latest'),
    () => apiGet<IStreamersReviewsResult>(URLS.STREAMERS_LATEST_REVIEWS),
    { skip: options?.skip }
  );

export const useStreamerReviewsGraphQuery = (
  payload: { id: string },
  options?: HookQueryOptions
) =>
  useQuery<PaginationResponse<ICasinoReviewGraph>>(
    queryKey('streamerReviews.graph', payload),
    () =>
      apiGet<PaginationResponse<ICasinoReviewGraph>>(
        `${URLS.REVIEWS_GRAPG_BY_STREAMER}${payload.id}`
      ),
    { skip: options?.skip || !payload?.id }
  );

export const useStreamerReviewQuery = (
  payload: { id: string },
  options?: HookQueryOptions
) =>
  useQuery<PaginationResponse<ICasinoReview>>(
    queryKey('streamerReviews.byStreamer', payload),
    () =>
      apiGet<PaginationResponse<ICasinoReview>>(
        `${URLS.REVIEWS_BY_STREAMER}${payload.id}`
      ),
    { skip: options?.skip || !payload?.id }
  );

export const useToogleLikeMutation = () =>
  useMutation<ToogleLikeRequest, void>(({ reviewId }) =>
    apiRequest<void>(URLS.CASINO_REVIEWS_LIKES, {
      method: 'POST',
      auth: true,
      body: { review_id: reviewId },
    })
  );

export const useToogleDislikeMutation = () =>
  useMutation<ToogleLikeRequest, void>(({ reviewId }) =>
    apiRequest<void>(URLS.CASINO_REVIEWS_DISLIKES, {
      method: 'POST',
      auth: true,
      body: { review_id: reviewId },
    })
  );

export const useCreateStreamerReviewsMutation = () =>
  useMutation<CreateStreamerReviewsRequest, void>(
    ({ streamerId, rating, review }) =>
      apiRequest<void>(URLS.STREAMERS_REVIEWS, {
        method: 'POST',
        auth: true,
        body: {
          streamer_id: streamerId,
          rating,
          review,
        },
      })
  );

export const useUpdateStreamerReviewsMutation = () =>
  useMutation<CreateStreamerReviewsRequest, void>(
    ({ streamerId, rating, review }) =>
      apiRequest<void>(URLS.CASINO_REVIEWS_UPDATE, {
        method: 'POST',
        auth: true,
        body: {
          streamerId,
          rating,
          review,
        },
      })
  );

export const useDeleteStreamerReviewsMutation = () =>
  useMutation<{ id: string }, void>(({ id }) =>
    apiRequest<void>(URLS.STREAMERS_REVIEWS, {
      method: 'DELETE',
      auth: true,
      body: { id },
    })
  );
